<template>
	<div>
		<div class="row">
			<!--  CEP -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.cep != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span>{{ _traducao('menuAGnovoUsuario', 'menuAGcep') }}:</label
				>
				<input v-model="form.cep" @blur="buscaCep(tipo, form.cep)" class="form-control input-sm" v-mask="_vcep" />
				<p class="help-block" v-show="erro.cep != ''">{{ erro.cep }}</p>
			</div>

			<!--  LOGRADOURO -->
			<div class="col-xs-12 col-md-6 form-group" :class="{'has-error': erro.logradouro != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGlogradouro') }}:</label
				>
				<input type="text" v-model="form.logradouro" class="form-control input-sm" />
				<p class="help-block" v-show="erro.logradouro != ''">{{ erro.logradouro }}</p>
			</div>

			<!--  NUMERO -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.numero != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span>{{ _traducao('menuAGnovoUsuario', 'menuAGnum') }}:</label
				>
				<input v-model="form.numero" class="form-control input-sm" v-mask="_vinteiro(10)" />
				<p class="help-block" v-show="erro.numero != ''">{{ erro.numero }}</p>
			</div>
		</div>

		<div class="row">
			<!--  COMPLEMENTO -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.complemento != ''}">
				<label>{{ _traducao('menuAGnovoUsuario', 'menuAGcomplemento') }}:</label>
				<input type="text" v-model="form.complemento" class="form-control input-sm" />
				<p class="help-block" v-show="erro.complemento != ''">{{ erro.complemento }}</p>
			</div>

			<!--  BAIRRO -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.bairro != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGbairro') }}:</label
				>
				<input type="text" v-model="form.bairro" class="form-control input-sm" />
				<p class="help-block" v-show="erro.bairro != ''">{{ erro.bairro }}</p>
			</div>

			<!--  CIDADE -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.cidade != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGcidade') }}:</label
				>
				<input type="text" v-model="form.cidade" class="form-control input-sm" />
				<p class="help-block" v-show="erro.cidade != ''">{{ erro.cidade }}</p>
			</div>

			<!--  ESTADO -->
			<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.estado != ''}">
				<label
					><span class="no-print" v-show="camposObrigatorios">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGestado') }}:</label
				>
				<flSelectEstado :optionvalue="optionvalue" :value="form.estado" :name="tipo" @v-model="(val) => (form.estado = val)" />
				<p class="help-block" v-show="erro.estado != ''">{{ erro.estado }}</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		tipo: {
			type: String
		}
	},

	data() {
		return {
			camposObrigatorios: true,

			form: {
				cep: '',
				logradouro: '',
				numero: '',
				complemento: '',
				bairro: '',
				cidade: '',
				estado: ''
			},

			erro: {
				cep: '',
				logradouro: '',
				numero: '',
				complemento: '',
				bairro: '',
				cidade: '',
				estado: ''
			}
		}
	},

	computed: {
		optionvalue() {
			if ($cliente.get('id') == 4) {
				return 'NOME'
			}
			return 'SIGLA'
		}
	},

	created() {
		this.carregarParametros()
	},

	methods: {
		carregarParametros() {
			this._axios('Parametro/get/15', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status && typeof retorno.parametro === 'object') {
						this.camposObrigatorios = retorno.parametro.valor == 1
					}
				}
			})
		},

		editar(obj) {
			this.tipo = obj.tipo

			if (this.tipo == 'residencial') {
				;(this.form.cep = obj.item.cep), (this.form.logradouro = obj.item.logradouro)
				this.form.numero = obj.item.numero
				this.form.complemento = obj.item.complemento
				this.form.bairro = obj.item.bairro
				this.form.cidade = obj.item.cidade
				this.form.estado = obj.item.estado
			}

			if (this.tipo == 'funcional') {
				this.form.cep = obj.item.cep_funcional
				this.form.logradouro = obj.item.logradouro_funcional
				this.form.numero = obj.item.numero_funcional
				this.form.complemento = obj.item.complemento_funcional
				this.form.bairro = obj.item.bairro_funcional
				this.form.cidade = obj.item.cidade_funcional
				this.form.estado = obj.item.estado_funcional
			}

			if (this.tipo == 'emergencial') {
				this.form.cep = obj.item.cep_emergencia
				this.form.logradouro = obj.item.logradouro_emergencia
				this.form.numero = obj.item.numero_emergencia
				this.form.complemento = obj.item.complemento_emergencia
				this.form.bairro = obj.item.bairro_emergencia
				this.form.cidade = obj.item.cidade_emergencia
				this.form.estado = obj.item.estado_emergencia
			}
		},

		buscaCep(tipo, cep) {
			//console.log(cep);

			if ($cliente.get('id') != 4) {
				if (cep.length == 9) {
					var url = 'https://apps.widenet.com.br/busca-cep/api/cep/' + cep + '.json'
					jQuery.getJSON(url, (resultado) => {
						// achou cep
						if (resultado.status == 200) {
							if (tipo == 'residencial') {
								this.form.logradouro = resultado.address
								this.form.bairro = resultado.district
								this.form.cidade = resultado.city
								//this.form.estado = unescape(resultadoCEP.uf)
								bus.$emit('select-estado-seta', {name: 'residencial', val: resultado.state.toUpperCase()})
							}

							if (tipo == 'funcional') {
								this.form.logradouro = resultado.address
								this.form.bairro = resultado.district
								this.form.cidade = resultado.city
								//this.form.estado = unescape(resultadoCEP.uf)
								bus.$emit('select-estado-seta', {name: 'funcional', val: resultado.state.toUpperCase()})
							}

							if (tipo == 'emergencial') {
								this.form.logradouro = resultado.address
								this.form.bairro = resultado.district
								this.form.cidade = resultado.city
								//this.form.estado = unescape(resultadoCEP.uf)
								bus.$emit('select-estado-seta', {name: 'emergencial', val: resultado.state.toUpperCase()})
							}
						}
					})
				}
			}
		},

		validaForm() {
			let passou = true
			let obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.camposObrigatorios) {
				if (this.form.cep.trim() == '') {
					this.erro.cep = obrigatorio
					passou = false
				} else {
					this.erro.cep = ''
				}

				if (this.form.logradouro.trim() == '') {
					this.erro.logradouro = obrigatorio
					passou = false
				} else {
					this.erro.logradouro = ''
				}

				if (this.form.numero.trim() == '') {
					this.erro.numero = obrigatorio
					passou = false
				} else {
					this.erro.numero = ''
				}

				if (this.form.bairro.trim() == '') {
					this.erro.bairro = obrigatorio
					passou = false
				} else {
					this.erro.bairro = ''
				}

				if (this.form.cidade.trim() == '') {
					this.erro.cidade = obrigatorio
					passou = false
				} else {
					this.erro.cidade = ''
				}

				if (this.form.estado.trim() == '') {
					this.erro.estado = obrigatorio
					passou = false
				} else {
					this.erro.estado = ''
				}
			}

			if (passou) {
				this.$emit('dados-endereco-residencial', this.form)

				this.$emit('dados-endereco-funcional', this.form)

				this.$emit('dados-endereco-emergencia', this.form)
			}

			return passou
		}
	}
}
</script>